import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useParams } from "react-router-dom";
import { FaUsers } from "react-icons/fa";

/* Products will be fetched from API */

function CreateCustomer() {
  const { id } = useParams();
  const isEditMode = !!id;
  const [products, setProducts] = useState([]);
  const [form, setForm] = useState({
    name: "",
    mobile: "",
    email: "",
    address: "",
    balance: "",
    reminder: "None",
    products: [],
  });

  const [errors, setErrors] = useState({});
  const [showEmailInput, setShowEmailInput] = useState(false);
  const [additionalEmail, setAdditionalEmail] = useState("");

  // Fetch products from API
  const fetchProducts = async () => {
    try {
      const response = await fetch('https://ctmapi.zerlak.com/api/v1/goods/getAllGoods', {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch goods');
      }

      const goodsData = await response.json();
      console.log('Goods data:', goodsData);

      // Transform API data to product format
      const transformedProducts = goodsData.map((item, index) => ({
        id: item.id,
        name: item.name,
        action: "Del",
        qty: 0,
      }));

      setProducts(transformedProducts);
      setForm(prev => ({
        ...prev,
        products: transformedProducts
      }));

    } catch (error) {
      console.error('Error fetching products:', error);
      toast.error("Failed to fetch products");
      
      // Fallback to default products
      const fallbackProducts = [
        { id: 1, name: "Big Floron", action: "Del", qty: 0 },
        { id: 2, name: "Big Regular", action: "Del", qty: 0 },
        { id: 3, name: "Small Floron", action: "Del", qty: 0 },
        { id: 4, name: "Small Regular", action: "Del", qty: 0 },
      ];
      setProducts(fallbackProducts);
      setForm(prev => ({
        ...prev,
        products: fallbackProducts
      }));
    }
  };

  // Fetch products on component mount
  useEffect(() => {
    fetchProducts();
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleProductChange = (index, field, value) => {
    const newProducts = [...form.products];
    newProducts[index] = { ...newProducts[index], [field]: value };
    setForm({ ...form, products: newProducts });
  };

  const validate = () => {
    let temp = {};
    temp.name = form.name ? "" : "Required";
    temp.mobile = form.mobile ? "" : "Required";
    temp.email = /^\S+@\S+\.\S+$/.test(form.email)
      ? ""
      : "Valid email required";
    temp.address = form.address ? "" : "Required";

    setErrors(temp);
    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) {
      toast.warning("Please fill required fields correctly");
      return;
    }

    try {
      const payload = {
        name: form.name,
        contactNumber: form.mobile,
        email: form.email,
        address: form.address,
        reminder: form.reminder,
        deposite: Number(form.balance) || 0,
        items: form.products.map((p) => ({
          goodsItemId: p.id, // ✅ Now sending INTEGER
          name: p.name,
          deliveredQty: p.action === "Del" ? p.qty : 0,
          receivedQty: p.action === "Rec" ? p.qty : 0,
        })),
      };

    
      
      const url = isEditMode
  ? `https://ctmapi.zerlak.com/api/v1/customers/update/${id}`
  : "https://ctmapi.zerlak.com/api/v1/customers/save";

const method = isEditMode ? "PUT" : "POST";

const response = await fetch(url, {
  method: method,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  },
  body: JSON.stringify(payload),
});

      if (!response.ok) throw new Error("Failed");

      toast.success("Customer created successfully");
      handleReset();
    } catch (err) {
      toast.error("Error: " + err.message);
    }
  };

  const handleReset = () => {
    setForm({
      name: "",
      mobile: "",
      email: "",
      address: "",
      balance: "",
      reminder: "None",
      products: products.map((p) => ({
        id: p.id,
        name: p.name,
        action: "Del",
        qty: 0,
      })),
    });
    setAdditionalEmail("");
    setErrors({});
  };
  useEffect(() => {
  if (id) {
    fetchCustomerById(id);
  }
}, [id]);

// const fetchCustomerById = async (id) => {
//    try {
//   //   const res = await fetch(`https://ctmapi.zerlak.com/api/v1/customers/${id}`, {
//   //     headers: {
//   //       Authorization: `Bearer ${localStorage.getItem("token")}`,
//   //     },
//   //   });
//  const res = await fetch(`https://ctmapi.zerlak.com/api/v1/customers/getById/${id}`, {
//   headers: {
//     "Content-Type": "application/json",   // ✅ ADD THIS
//     Authorization: `Bearer ${localStorage.getItem("token")}`,
//   },
// });
//     const data = await res.json();

//     setForm({
//       name: data.name || "",
//       mobile: data.contactNumber || "",
//       email: data.email || "",
//       address: data.address || "",
//       balance: data.deposite || "",
//       reminder: data.reminder || "None",
//       products: productsList.map((p) => {
//         const existingItem = data.items?.find(
//           (item) => item.goodsItemId === p.id
//         );

//         return {
//           id: p.id,
//           name: p.name,
//           action:
//             existingItem?.deliveredQty > 0 ? "Del" : "Rec",
//           qty:
//             existingItem?.deliveredQty ||
//             existingItem?.receivedQty ||
//             0,
//         };
//       }),
//     });
//   } catch (err) {
//     toast.error("Failed to fetch customer");
//   }
const fetchCustomerById = async (id) => {
  try {
    const res = await fetch(
      `https://ctmapi.zerlak.com/api/v1/customers/getById/${id}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    if (!res.ok) throw new Error("Unauthorized");

    const data = await res.json();

    setForm({
      name: data.name || "",
      mobile: data.contactNumber || "",
      email: data.email || "",
      address: data.address || "",
      balance: data.deposite || "",
      reminder: data.reminder || "None",
      products: products.map((p) => {
        const existingItem = data.items?.find(
          (item) => item.goodsItemId === p.id
        );

        return {
          id: p.id,
          name: p.name,
          action: existingItem?.deliveredQty > 0 ? "Del" : "Rec",
          qty:
            existingItem?.deliveredQty ||
            existingItem?.receivedQty ||
            0,
        };
      }),
    });
  } catch (err) {
    toast.error("Error: " + err.message);
  }
};

  return (
    <div style={{ 
      padding: '20px',
      maxWidth: '100vw',
      overflowX: 'hidden',
      minHeight: '100vh',
      boxSizing: 'border-box'
    }}>
      <ToastContainer position="top-right" autoClose={3000} />

      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        marginBottom: '20px',
        flexWrap: 'wrap',
        gap: '10px',
        width: '100%',
        boxSizing: 'border-box'
      }}>
        <div style={{ 
          display: 'flex', 
          alignItems: 'center',
          gap: '12px'
        }}>
          <FaUsers style={{ 
            fontSize: 'clamp(1.5rem, 4vw, 2rem)',
            color: '#3b82f6'
          }} />
          <h2 style={{ 
            margin: 0,
            fontSize: 'clamp(1.2rem, 4vw, 1.8rem)',
            fontWeight: 'bold',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            color: '#1e293b'
          }}>
            {isEditMode ? "Edit Customer" : "Create Customer"}
          </h2>
        </div>
      </div>

      <div className="form-card">
        <form onSubmit={handleSubmit}>

          {/* ================= CUSTOMER INFORMATION ================= */}
          <div className="section">
            <h3 className="section-title">Customer Information</h3>

            <div className="form-grid">
              <div className="form-group">
                <label htmlFor="name" className="form-label">
                  Customer Name <span className="required">*</span>
                </label>
                <input
                  id="name"
                  type="text"
                  name="name"
                  className="form-input"
                  placeholder="Enter customer name"
                  value={form.name}
                  onChange={handleChange}
                />
                {errors.name && <span className="error-message">{errors.name}</span>}
              </div>

              <div className="form-group">
                <label htmlFor="mobile" className="form-label">
                  Mobile Number <span className="required">*</span>
                </label>
                <input
                  id="mobile"
                  type="tel"
                  name="mobile"
                  className="form-input"
                  placeholder="Enter mobile number"
                  value={form.mobile}
                  onChange={handleChange}
                />
                {errors.mobile && <span className="error-message">{errors.mobile}</span>}
              </div>

              <div className="form-group">
                <label htmlFor="email" className="form-label">
                  Email Address <span className="required">*</span>
                </label>
                <input
                  id="email"
                  type="email"
                  name="email"
                  className="form-input"
                  placeholder="Enter email address"
                  value={form.email}
                  onChange={handleChange}
                />
                {errors.email && <span className="error-message">{errors.email}</span>}
              </div>

              <div className="form-group">
                <label htmlFor="address" className="form-label">
                  Address <span className="required">*</span>
                </label>
                <input
                  id="address"
                  type="text"
                  name="address"
                  className="form-input"
                  placeholder="Enter complete address"
                  value={form.address}
                  onChange={handleChange}
                />
                {errors.address && <span className="error-message">{errors.address}</span>}
              </div>

              <div className="form-group" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <button 
                  type="button" 
                  onClick={() => setShowEmailInput(!showEmailInput)}
                  style={{
                    width: 'fit-content',
                    padding: '6px 14px',
                    border: '1px solid #3b82f6',
                    borderRadius: '4px',
                    backgroundColor: '#3b82f6',
                    color: '#ffffff',
                    fontSize: '13px',
                    fontWeight: '500',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    textDecoration: 'none',
                    boxShadow: '0 1px 3px rgba(59, 130, 246, 0.2)'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#2563eb';
                    e.target.style.borderColor = '#2563eb';
                    e.target.style.boxShadow = '0 4px 8px rgba(59, 130, 246, 0.2)';
                    e.target.style.transform = 'translateY(-1px)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '#3b82f6';
                    e.target.style.borderColor = '#3b82f6';
                    e.target.style.boxShadow = '0 2px 4px rgba(59, 130, 246, 0.1)';
                    e.target.style.transform = 'translateY(0)';
                  }}
                >
                  <span style={{ fontSize: '16px', fontWeight: 'bold' }}>
                    {showEmailInput ? '×' : '+'}
                  </span>
                  {showEmailInput ? "Hide Email" : "Add another email"}
                </button>
              </div>

              {showEmailInput && (
                <div className="form-group">
                  <label htmlFor="additionalEmail" className="form-label">
                    Additional Email <span className="required">*</span>
                  </label>
                  <input
                    id="additionalEmail"
                    type="email"
                    name="additionalEmail"
                    className="form-input"
                    placeholder="Enter additional email address"
                    value={additionalEmail}
                    onChange={(e) => setAdditionalEmail(e.target.value)}
                  />
                  {errors.email && <span className="error-message">{errors.email}</span>}
                </div>
              )}

            </div>
          </div>

          {/* ================= EMAIL ACTIONS ================= */}
          
          {/* ================= FINANCIAL INFORMATION ================= */}
          <div className="section">
            <h3 className="section-title">Financial Information</h3>

            <div className="form-grid">
              <div className="form-group">
                <label htmlFor="balance" className="form-label">
                  Opening Balance
                </label>
                <input
                  id="balance"
                  type="number"
                  name="balance"
                  className="form-input"
                  placeholder="0.00"
                  value={form.balance}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label htmlFor="reminder" className="form-label">
                  Reminder Settings
                </label>
                <select
                  id="reminder"
                  name="reminder"
                  className="form-select"
                  value={form.reminder}
                  onChange={handleChange}
                >
                  <option value="None">No Reminder</option>
                  <option value="Daily">Daily</option>
                  <option value="Weekly">Weekly</option>
                  <option value="Monthly">Monthly</option>
                </select>
              </div>
            </div>
          </div>

          {/* ================= PRODUCT PREFERENCE ================= */}
          <div className="section">
            <h3 className="section-title">Product Preference</h3>

            <div className="table-card">
              <table className="product-table">
                <thead>
                  <tr>
                    <th>Product Name</th>
                    <th>Action Type</th>
                    <th>Default Quantity</th>
                  </tr>
                </thead>
                <tbody>
                  {form.products.map((prod, idx) => (
                    <tr key={idx}>
                      <td className="product-name">{prod.name}</td>
                      <td>
                        <select
                          className="form-select"
                          value={prod.action}
                          onChange={(e) =>
                            handleProductChange(idx, "action", e.target.value)
                          }
                        >
                          <option value="Del">Delivered</option>
                          <option value="Rec">Received</option>
                        </select>
                      </td>
                      <td>
                        <input
                          type="number"
                          min="0"
                          className="form-input quantity-input"
                          placeholder="0"
                          value={prod.qty}
                          onChange={(e) =>
                            handleProductChange(
                              idx,
                              "qty",
                              Number(e.target.value)
                            )
                          }
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* ================= BUTTONS ================= */}
          <div className="form-actions">
            <button type="button" className="btn btn-secondary" onClick={handleReset}>
              <span className="btn-icon">↺</span>
              Reset Form
            </button>
            <button type="submit" className="btn btn-primary">
              <span className="btn-icon">✓</span>
              {isEditMode ? "Update Customer" : "Create Customer"}
            </button>
          </div>

        </form>
      </div>
    </div>
  );
}

export default CreateCustomer;